export const SIDER_WIDTH = 248;
export const SIDER_COLLAPSED_WIDTH = 48;
export const APP_MIN_WIDTH = 1440;
export const APP_HEADER_HEIGHT = 64;
export const TABLE_ACTION_HEADER_HEIGHT = 116;
